import React, { useState, useRef, useEffect } from "react";
import styles from "./VendorPanel.module.css";

const makeEmptySlots = () =>
  Array.from({ length: 5 }, () => ({ name: "", id: null, show: false, highlight: -1 }));

export default function VendorPanel({ vendors, loadingVendors, onChange, initialVendors }) {
  // ✅ 거래처 1~5 각 열의 드롭다운 컨테이너 ref — 하이라이트 이동 시 자동 스크롤용
  const dropdownRefs = useRef([]);
  // ✅ initialVendors는 "이전 건 복사" 등 외부에서 최초 진입 값을 주입할 때만 사용 —
  // 부모가 key prop을 바꿔 리마운트시켜야 반영된다(내부 상태는 마운트 시 1회만 초기화됨).
  // 고정 5칸 구조이므로 원본 거래처를 앞칸부터 채우고 나머지는 빈칸으로 둔다.
  const [list, setList] = useState(() => {
    const base = makeEmptySlots();
    if (initialVendors?.length) {
      initialVendors.slice(0, 5).forEach((v, i) => {
        base[i] = { name: v.name || "", id: v.id || null, show: false, highlight: -1 };
      });
    }
    return base;
  });

  // ✅ ↓/↑로 하이라이트가 이동해도 화면 밖으로 나가지 않도록 항상 보이는 위치로 스크롤
  useEffect(() => {
    list.forEach((v, idx) => {
      if (v.highlight >= 0) {
        dropdownRefs.current[idx]?.children?.[v.highlight]?.scrollIntoView({ block: "nearest" });
      }
    });
  }, [list]);

  const handleChange = (idx, value) => {
    const newList = [...list];
    newList[idx].name = value;
    newList[idx].id = null;
    newList[idx].show = true;
    newList[idx].highlight = 0;
    setList(newList);
    onChange && onChange(newList);
  };

  const handleKeyDown = (idx, e) => {
    const filtered = vendors.filter(vv =>
      vv.name.toLowerCase().includes(list[idx].name.toLowerCase())
    );

    if (!list[idx].show || !filtered.length) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      const newList = [...list];
      newList[idx].highlight =
        newList[idx].highlight < filtered.length - 1
          ? newList[idx].highlight + 1
          : 0;
      setList(newList);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      const newList = [...list];
      newList[idx].highlight =
        newList[idx].highlight > 0
          ? newList[idx].highlight - 1
          : filtered.length - 1;
      setList(newList);
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (list[idx].highlight >= 0) {
        const vv = filtered[list[idx].highlight];
        selectVendor(idx, vv);
      }
    } else if (e.key === "Escape") {
      const newList = [...list];
      newList[idx].show = false;
      setList(newList);
    }
  };

  const selectVendor = (idx, vendor) => {
    const newList = [...list];
    newList[idx].name = vendor.name;
    newList[idx].id = vendor.id;
    newList[idx].show = false;
    setList(newList);
    onChange && onChange(newList);
  };

  return (
    <div className={styles.sidePane}>
      <div className={styles.scrollWrap}>
        <table className={styles.vendorTable}>
          <thead>
            <tr>
              <th>[ALT+5] 거래처 1</th>
              <th>거래처 2</th>
              <th>거래처 3</th>
              <th>거래처 4</th>
              <th>거래처 5</th>  

            </tr>
          </thead>
          <tbody>
            <tr className={styles.inputRow}>
              {list.map((v, idx) => {
                const filtered = vendors.filter(vv =>
                  vv.name.toLowerCase().includes(v.name.toLowerCase())
                );

                return (
                  <td key={idx} style={{ position: "relative", overflow: "visible" }}>

                    <input
                      value={v.name}
                      onChange={(e) => handleChange(idx, e.target.value)}
                      onFocus={() => {
                        const newList = [...list];
                        newList[idx].show = true;
                        setList(newList);
                      }}
                      onKeyDown={(e) => handleKeyDown(idx, e)}
                      placeholder={`거래처 ${idx + 1}`}
                    />
                    
                    {v.show && (
                      <div
                        className={styles.vendorDropdown}
                        ref={(el) => { dropdownRefs.current[idx] = el; }}
                      >
                        {loadingVendors && <div>불러오는 중...</div>}
                        {filtered.length ? (
                          filtered.map((vv, i) => (
                            <div
                              key={vv.id}
                              className={`${styles.vendorItem} ${i === v.highlight ? styles.activeItem : ""}`}
                              onClick={() => selectVendor(idx, vv)}
                            >
                              {vv.name}
                            </div>
                          ))
                        ) : (
                          <div className={styles.vendorItem}>일치하는 거래처 없음</div>
                        )}
                      </div>
                    )}
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}